module.exports = __webpack_public_path__ + "img/bay.9cfef4ee.svg";